import { types } from "../types/types";

export const uiOpenModalStore = () => ({
    type: types.uiOpenModalStore
});

export const uiCloseModalStore = () => ({
    type: types.uiCloseModalStore
});